import { render, staticRenderFns } from "./ProposalMain.vue?vue&type=template&id=d0ef5802"
import script from "./ProposalMain.vue?vue&type=script&lang=js"
export * from "./ProposalMain.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports